"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var TopicSpecificationSerialiser = require("./../../topics/details/topic-specification-serialiser");
var UpdateConstraintSerialiser = require("./update-constraint-serialiser");
/**
 * Serialiser for {@link AddAndSetTopicRequest}
 */
var AddAndSetTopicRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(AddAndSetTopicRequestSerialiserClass, _super);
    function AddAndSetTopicRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link AddAndSetTopicRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link AddAndSetTopicRequest} to be written
     */
    AddAndSetTopicRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        TopicSpecificationSerialiser.write(bos, value.topicSpecification);
        Codec.writeBytes(bos, value.value);
        UpdateConstraintSerialiser.write(bos, value.constraint);
    };
    return AddAndSetTopicRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.AddAndSetTopicRequestSerialiserClass = AddAndSetTopicRequestSerialiserClass;
/**
 * The {@link AddAndSetTopicRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.AddAndSetTopicRequestSerialiser = new AddAndSetTopicRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/add-and-set-topic-request-serialiser.js
// module id = 1477
// module chunks = 0